import _objectWithoutProperties from "/Users/aronam/Library/CloudStorage/OneDrive-Chalmers/Documents/GitHub/Arctic-Webcams/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _createClass from "/Users/aronam/Library/CloudStorage/OneDrive-Chalmers/Documents/GitHub/Arctic-Webcams/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/Users/aronam/Library/CloudStorage/OneDrive-Chalmers/Documents/GitHub/Arctic-Webcams/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/aronam/Library/CloudStorage/OneDrive-Chalmers/Documents/GitHub/Arctic-Webcams/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/aronam/Library/CloudStorage/OneDrive-Chalmers/Documents/GitHub/Arctic-Webcams/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/aronam/Library/CloudStorage/OneDrive-Chalmers/Documents/GitHub/Arctic-Webcams/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/aronam/Library/CloudStorage/OneDrive-Chalmers/Documents/GitHub/Arctic-Webcams/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/aronam/Library/CloudStorage/OneDrive-Chalmers/Documents/GitHub/Arctic-Webcams/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/Users/aronam/Library/CloudStorage/OneDrive-Chalmers/Documents/GitHub/Arctic-Webcams/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _defineProperty from "/Users/aronam/Library/CloudStorage/OneDrive-Chalmers/Documents/GitHub/Arctic-Webcams/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/Users/aronam/Library/CloudStorage/OneDrive-Chalmers/Documents/GitHub/Arctic-Webcams/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/Users/aronam/Library/CloudStorage/OneDrive-Chalmers/Documents/GitHub/Arctic-Webcams/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/Users/aronam/Library/CloudStorage/OneDrive-Chalmers/Documents/GitHub/Arctic-Webcams/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

/*! MIT License © Sindre Sorhus */
var getGlobal = function getGlobal(property) {
  /* istanbul ignore next */
  if (typeof self !== 'undefined' && self && property in self) {
    return self[property];
  }
  /* istanbul ignore next */


  if (typeof window !== 'undefined' && window && property in window) {
    return window[property];
  }

  return global[property];
};

var document = getGlobal('document');
var Headers = getGlobal('Headers');
var Response = getGlobal('Response');
var fetch = getGlobal('fetch');

var isObject = function isObject(value) {
  return value !== null && typeof value === 'object';
};

var deepMerge = function deepMerge() {
  var returnValue = {};

  for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
    sources[_key] = arguments[_key];
  }

  for (var _i = 0, _sources = sources; _i < _sources.length; _i++) {
    var source = _sources[_i];

    if (Array.isArray(source)) {
      if (!Array.isArray(returnValue)) {
        returnValue = [];
      }

      returnValue = [].concat(_toConsumableArray(returnValue), _toConsumableArray(source));
    } else if (isObject(source)) {
      for (var _i2 = 0, _Object$entries = Object.entries(source); _i2 < _Object$entries.length; _i2++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        if (isObject(value) && Reflect.has(returnValue, key)) {
          value = deepMerge(returnValue[key], value);
        }

        returnValue = _objectSpread({}, returnValue, _defineProperty({}, key, value));
      }
    }
  }

  return returnValue;
};

var requestMethods = ['get', 'post', 'put', 'patch', 'head', 'delete'];
var responseTypes = ['json', 'text', 'formData', 'arrayBuffer', 'blob'];
var retryMethods = new Set(['get', 'put', 'head', 'delete', 'options', 'trace']);
var retryStatusCodes = new Set([408, 413, 429, 500, 502, 503, 504]);
var retryAfterStatusCodes = new Set([413, 429, 503]);

var HTTPError =
/*#__PURE__*/
function (_Error) {
  _inherits(HTTPError, _Error);

  function HTTPError(response) {
    var _this;

    _classCallCheck(this, HTTPError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HTTPError).call(this, response.statusText));
    _this.name = 'HTTPError';
    _this.response = response;
    return _this;
  }

  return HTTPError;
}(_wrapNativeSuper(Error));

var TimeoutError =
/*#__PURE__*/
function (_Error2) {
  _inherits(TimeoutError, _Error2);

  function TimeoutError() {
    var _this2;

    _classCallCheck(this, TimeoutError);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(TimeoutError).call(this, 'Request timed out'));
    _this2.name = 'TimeoutError';
    return _this2;
  }

  return TimeoutError;
}(_wrapNativeSuper(Error));

var delay = function delay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};

var timeout = function timeout(promise, ms) {
  return Promise.race([promise, _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return delay(ms);

          case 2:
            throw new TimeoutError();

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }))()]);
};

var normalizeRequestMethod = function normalizeRequestMethod(input) {
  return requestMethods.includes(input) ? input.toUpperCase() : input;
};

var Ky =
/*#__PURE__*/
function () {
  function Ky(input, _ref2) {
    var _this3 = this;

    var _ref2$timeout = _ref2.timeout,
        timeout = _ref2$timeout === void 0 ? 10000 : _ref2$timeout,
        hooks = _ref2.hooks,
        _ref2$throwHttpErrors = _ref2.throwHttpErrors,
        throwHttpErrors = _ref2$throwHttpErrors === void 0 ? true : _ref2$throwHttpErrors,
        searchParams = _ref2.searchParams,
        json = _ref2.json,
        otherOptions = _objectWithoutProperties(_ref2, ["timeout", "hooks", "throwHttpErrors", "searchParams", "json"]);

    _classCallCheck(this, Ky);

    this._retryCount = 0;
    this._options = _objectSpread({
      method: 'get',
      credentials: 'same-origin',
      // TODO: This can be removed when the spec change is implemented in all browsers. Context: https://www.chromestatus.com/feature/4539473312350208
      retry: 2
    }, otherOptions);
    this._options.method = normalizeRequestMethod(this._options.method);
    this._options.prefixUrl = String(this._options.prefixUrl || '');
    this._input = String(input || '');

    if (this._options.prefixUrl && this._input.startsWith('/')) {
      throw new Error('`input` must not begin with a slash when using `prefixUrl`');
    }

    if (this._options.prefixUrl && !this._options.prefixUrl.endsWith('/')) {
      this._options.prefixUrl += '/';
    }

    this._input = this._options.prefixUrl + this._input;

    if (searchParams) {
      var url = new URL(this._input, document && document.baseURI);

      if (typeof searchParams === 'string' || URLSearchParams && searchParams instanceof URLSearchParams) {
        url.search = searchParams;
      } else if (Object.values(searchParams).every(function (param) {
        return typeof param === 'number' || typeof param === 'string';
      })) {
        url.search = new URLSearchParams(searchParams).toString();
      } else {
        throw new Error('The `searchParams` option must be either a string, `URLSearchParams` instance or an object with string and number values');
      }

      this._input = url.toString();
    }

    this._timeout = timeout;
    this._hooks = deepMerge({
      beforeRequest: [],
      afterResponse: []
    }, hooks);
    this._throwHttpErrors = throwHttpErrors;
    var headers = new Headers(this._options.headers || {});

    if (json) {
      headers.set('content-type', 'application/json');
      this._options.body = JSON.stringify(json);
    }

    this._options.headers = headers;
    this._response = this._fetch();

    var _loop = function _loop() {
      var type = _responseTypes[_i3];
      var isRetriableMethod = retryMethods.has(_this3._options.method.toLowerCase());

      var fn =
      /*#__PURE__*/
      function () {
        var _ref3 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee2() {
          var response, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, hook, modifiedResponse;

          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (_this3._retryCount > 0) {
                    _this3._response = _this3._fetch();
                  }

                  _context2.next = 3;
                  return _this3._response;

                case 3:
                  response = _context2.sent;
                  _iteratorNormalCompletion = true;
                  _didIteratorError = false;
                  _iteratorError = undefined;
                  _context2.prev = 7;
                  _iterator = _this3._hooks.afterResponse[Symbol.iterator]();

                case 9:
                  if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                    _context2.next = 18;
                    break;
                  }

                  hook = _step.value;
                  _context2.next = 13;
                  return hook(response.clone());

                case 13:
                  modifiedResponse = _context2.sent;

                  if (modifiedResponse instanceof Response) {
                    response = modifiedResponse;
                  }

                case 15:
                  _iteratorNormalCompletion = true;
                  _context2.next = 9;
                  break;

                case 18:
                  _context2.next = 24;
                  break;

                case 20:
                  _context2.prev = 20;
                  _context2.t0 = _context2["catch"](7);
                  _didIteratorError = true;
                  _iteratorError = _context2.t0;

                case 24:
                  _context2.prev = 24;
                  _context2.prev = 25;

                  if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                  }

                case 27:
                  _context2.prev = 27;

                  if (!_didIteratorError) {
                    _context2.next = 30;
                    break;
                  }

                  throw _iteratorError;

                case 30:
                  return _context2.finish(27);

                case 31:
                  return _context2.finish(24);

                case 32:
                  if (!(!response.ok && (isRetriableMethod || _this3._throwHttpErrors))) {
                    _context2.next = 34;
                    break;
                  }

                  throw new HTTPError(response);

                case 34:
                  return _context2.abrupt("return", response.clone()[type]());

                case 35:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[7, 20, 24, 32], [25,, 27, 31]]);
        }));

        return function fn() {
          return _ref3.apply(this, arguments);
        };
      }();

      _this3._response[type] = isRetriableMethod ? _this3._retry(fn) : fn;
    };

    for (var _i3 = 0, _responseTypes = responseTypes; _i3 < _responseTypes.length; _i3++) {
      _loop();
    }

    return this._response;
  }

  _createClass(Ky, [{
    key: "_calculateRetryDelay",
    value: function _calculateRetryDelay(error) {
      this._retryCount++;

      if (this._retryCount < this._options.retry && !(error instanceof TimeoutError)) {
        if (error instanceof HTTPError) {
          if (!retryStatusCodes.has(error.response.status)) {
            return 0;
          }

          var retryAfter = error.response.headers.get('Retry-After');

          if (retryAfter && retryAfterStatusCodes.has(error.response.status)) {
            var after = Number(retryAfter);

            if (Number.isNaN(after)) {
              after = Date.parse(retryAfter) - Date.now();
            } else {
              after *= 1000;
            }

            return after;
          }

          if (error.response.status === 413) {
            return 0;
          }
        }

        var BACKOFF_FACTOR = 0.3;
        return BACKOFF_FACTOR * Math.pow(2, this._retryCount - 1) * 1000;
      }

      return 0;
    }
  }, {
    key: "_retry",
    value: function _retry(fn) {
      var _this4 = this;

      var retry =
      /*#__PURE__*/
      function () {
        var _ref4 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee3() {
          var ms;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.prev = 0;
                  _context3.next = 3;
                  return fn();

                case 3:
                  return _context3.abrupt("return", _context3.sent);

                case 6:
                  _context3.prev = 6;
                  _context3.t0 = _context3["catch"](0);
                  ms = _this4._calculateRetryDelay(_context3.t0);

                  if (!(ms !== 0)) {
                    _context3.next = 13;
                    break;
                  }

                  _context3.next = 12;
                  return delay(ms);

                case 12:
                  return _context3.abrupt("return", retry());

                case 13:
                  if (!_this4._throwHttpErrors) {
                    _context3.next = 15;
                    break;
                  }

                  throw _context3.t0;

                case 15:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[0, 6]]);
        }));

        return function retry() {
          return _ref4.apply(this, arguments);
        };
      }();

      return retry;
    }
  }, {
    key: "_fetch",
    value: function () {
      var _fetch2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, hook;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context4.prev = 3;
                _iterator2 = this._hooks.beforeRequest[Symbol.iterator]();

              case 5:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context4.next = 12;
                  break;
                }

                hook = _step2.value;
                _context4.next = 9;
                return hook(this._options);

              case 9:
                _iteratorNormalCompletion2 = true;
                _context4.next = 5;
                break;

              case 12:
                _context4.next = 18;
                break;

              case 14:
                _context4.prev = 14;
                _context4.t0 = _context4["catch"](3);
                _didIteratorError2 = true;
                _iteratorError2 = _context4.t0;

              case 18:
                _context4.prev = 18;
                _context4.prev = 19;

                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return();
                }

              case 21:
                _context4.prev = 21;

                if (!_didIteratorError2) {
                  _context4.next = 24;
                  break;
                }

                throw _iteratorError2;

              case 24:
                return _context4.finish(21);

              case 25:
                return _context4.finish(18);

              case 26:
                return _context4.abrupt("return", timeout(fetch(this._input, this._options), this._timeout));

              case 27:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[3, 14, 18, 26], [19,, 21, 25]]);
      }));

      function _fetch() {
        return _fetch2.apply(this, arguments);
      }

      return _fetch;
    }()
  }]);

  return Ky;
}();

var createInstance = function createInstance() {
  var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!isObject(defaults) || Array.isArray(defaults)) {
    throw new TypeError('The `defaultOptions` argument must be an object');
  }

  var ky = function ky(input, options) {
    return new Ky(input, deepMerge({}, defaults, options));
  };

  var _loop2 = function _loop2() {
    var method = _requestMethods[_i4];

    ky[method] = function (input, options) {
      return new Ky(input, deepMerge({}, defaults, options, {
        method: method
      }));
    };
  };

  for (var _i4 = 0, _requestMethods = requestMethods; _i4 < _requestMethods.length; _i4++) {
    _loop2();
  }

  ky.extend = function (defaults) {
    return createInstance(defaults);
  };

  return ky;
};

export default createInstance();
export { HTTPError, TimeoutError };